import SectionTypeList from './SectionTypeList';

export default SectionTypeList;
